import { getWmsServiceUrl } from '../../setup';
import Service from './service';
import { APIVersion, ServiceTypes } from '../../types/main';

class Compliance extends Service {
    static filterQuestionnaires(data) {
        return Service.postRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/questionnaires/search?language=${data?.Language}`,
            data,
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static searchQuestionnairesByContact({ contactId, questionnaireTypeId, language }) {
        return Service.getRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/questionnaires?questionnaireTypeId=${questionnaireTypeId}&language=${language}`,
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static searchQuestionnairesByContactWithSubmissionId({ contactId, submissionId, language }) {
        return Service.getRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/questionnaires/${submissionId}?language=${language}`,
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static postAnswers({ contactId, data }) {
        return Service.postRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/questionnaires`,
            data,
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static calculateRisk({ contactId, ProductIds, language = 'en' }) {
        return Service.postRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/questionnaires/risk-profiling/calculate?language=${language}`,
            { ProductIds },
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static acceptRisk({ contactId, ProductIds, SubmissionId }) {
        return Service.postRequest(
            `${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/questionnaires/risk-profiling/accept`,
            { ProductIds, SubmissionId },
            { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN },
        );
    }

    static setChosenRisk({ contactId, chosenRiskId }) {
        return Service.putRequest(`${getWmsServiceUrl(APIVersion.V20)}/contacts/${contactId}/chosen-risk`, { RiskCategoryId: chosenRiskId }, { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN });
    }
}

export default Compliance;
